import {
  Avatar,
  Box,
  HStack,
  Pressable,
  Text,
  Tooltip,
  VStack,
  useMediaQuery
} from 'native-base';
import CryptoJS from 'crypto-js';
import EventDetails from '../../../containers/eventDetails';
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from '../../../utils/fonts';
import CustomButton from '../../../components/button';
import { COLORS } from '../../../utils/colors';
import { editIconBannerImage, editIconDetailsPage } from '../../../utils/svg';
import { useEffect, useState } from 'react';
import CustomModal from '../../../components/modal';
import FileUploader from '../../../containers/fileUpload';
import ViewUploadImageCards from '../../../containers/viewUploadImageCards';
import { MOBILE_VIEW_WIDTH } from '../../../utils/screens';
import { hasPermission, statusMap } from '../../../utils/permission';
import { useSelector } from 'react-redux';
import { LoaderAnimation } from '../../../components/spinner';
import { Toaster } from '../../../components/toaster';
import config from '../../../utils/config';
import { putWorkflowAPI, uploadFileAPI } from '../../../api/apis/workflow';
import MobileModelSheet from '../../../components/actionSheet';

const RequestDetail = ({
  scrollToTop = () => {},
  getEventDetails,
  workflow
}) => {
  const toaster = Toaster();
  const bytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem('content'),
    config.userKey
  );
  const jsonString = bytes.toString(CryptoJS.enc.Utf8);
  const userInfo = JSON.parse(jsonString);
  const [editBannerImage, setEditBannerImage] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH
  });
  const eventsDetail = useSelector((state) => {
    return state.event.selectedEvent;
  });
  const [forceRemount, setForceRemount] = useState(false);

  const openModal = () => {
    scrollToTop();
    setForceRemount(!forceRemount);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setForceRemount(!forceRemount);
    setSelectedFiles([]);
  };

  const isCoordinator = () => {
    if (!userInfo || !eventsDetail) return false;

    const userEmail = userInfo?.email;
    const coordinatorEmails = [
      eventsDetail?.contact_details?.email,
      eventsDetail?.contact_details?.email_2,
      eventsDetail?.contact_details?.email_3
    ]?.filter((email) => email);

    return coordinatorEmails?.includes(userEmail);
  };

  const handleFilesSelect = (file) => {
    const imageUrls = Array.from(file).map((item) => URL.createObjectURL(item));
    setSelectedFiles(imageUrls);
    setEditBannerImage(file);
  };

  const onDeleteImage = (ind) => {
    setEditBannerImage([]);
    setSelectedFiles([]);
  };

  function isValidDateFormat(dateString) {
    // Regular expression to match "YYYY-MM-DD" format
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    return regex.test(dateString);
  }

  const getStartDateFormat = (dateString) => {
    const date = new Date(dateString);
    function padTo2Digits(num) {
      return num.toString().padStart(2, '0');
    }
    function formatDate(date) {
      return (
        [
          date.getFullYear(),
          padTo2Digits(date.getMonth() + 1),
          padTo2Digits(date.getDate())
        ].join('-') +
        'T' +
        [
          padTo2Digits(date.getHours()),
          padTo2Digits(date.getMinutes()),
          padTo2Digits(date.getSeconds())
        ].join(':') +
        '.' +
        '616838+00:00'
      );
    }
    const formattedDate = formatDate(date);

    return formattedDate;
  };

  const getStartDateFormats = (dateString, type = 'start') => {
    const date = new Date(dateString);
    function padTo2Digits(num) {
      return num.toString().padStart(2, '0');
    }

    function formatDate(date, type) {
      let hours, minutes, seconds;
      if (type === 'start') {
        hours = minutes = seconds = '00';
      } else if (type === 'end') {
        hours = '23';
        minutes = '59';
        seconds = '00';
      } else {
        hours = padTo2Digits(date.getHours());
        minutes = padTo2Digits(date.getMinutes());
        seconds = padTo2Digits(date.getSeconds());
      }

      return (
        [
          date.getFullYear(),
          padTo2Digits(date.getMonth() + 1),
          padTo2Digits(date.getDate())
        ].join('-') +
        'T' +
        [hours, minutes, seconds].join(':') +
        '.616838+00:00'
      );
    }

    const formattedDate = formatDate(date, type);

    return formattedDate;
  };

  const uploadFilesToServer = async (data, type) => {
    let docs = [];
    let res = await uploadFileAPI(data, 'image', 'image');

    res.map((item) => {
      if (item.error) {
        toaster('Upload file failed', 'error', 'error');
        return;
      }
      if (item.data.data.data) {
        docs.push({
          doc_type: item.data.data.data.doc_type,
          file_size: item.data.data.data.file_size.toString(),
          file_name: item.data.data.data.file_name,
          uploaded_time: getStartDateFormat(new Date())
        });
      }
    });
    return docs;
  };

  return (
    <>
      <VStack space={6}>
        <HStack justifyContent={'space-between'}>
          <Text
            fontSize={COMMONFONTSIZE.HEADER_TEXT_FONT_SIZE}
            fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
          >
            Request Detail
          </Text>
          {
            hasPermission('EDIT_EVENT') &&
              statusMap.indexOf(eventsDetail.status) <= 3 &&
              isCoordinator() &&
              (!MobileWindow ? (
                <CustomButton
                  pl={0}
                  text={!MobileWindow && 'Edit Banner Image'}
                  startIcon={editIconBannerImage}
                  width='fit-content'
                  height='46'
                  textColor={COLORS.WHITE_COLOR}
                  fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
                  fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
                  onPress={() => {
                    openModal();
                  }}
                />
              ) : (
                <Pressable
                  onPress={() => {
                    openModal();
                  }}
                >
                  <Avatar
                    bg={'none'}
                    size={'md'}
                  >
                    {editIconBannerImage}
                  </Avatar>
                </Pressable>
              ))
            // <Tooltip label="Edit Banner Image">
            //   <Pressable
            //     alignItems={"center"}
            //     justifyContent={"center"}
            //     onPress={() => {
            //       openModal();
            //     }}
            //   >
            //     {editIconBannerImage}
            //   </Pressable>
            // </Tooltip>
          }
          {/* <CustomButton
          pl={0}
          text="Edit Banner Image"
          startIcon={editIconDetailsPage}
          width="fit-content"
          height="auto"
          textColor={COLORS.WHITE_COLOR}<
          fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
          fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
          onPress={() => {}}
        /> */}
        </HStack>
        <EventDetails
          workflow={workflow}
          getEventDetails={getEventDetails}
          scrollToTop={scrollToTop}
        />
      </VStack>
      {!MobileWindow ? (
        <CustomModal
          top={'50px'}
          isOpen={showModal}
          onClose={closeModal}
          header={'Upload Banner Image'}
          body={
            showModal && (
              <>
                <FileUploader
                  files={selectedFiles}
                  show={false}
                  setFiles={handleFilesSelect}
                  accept={['png', 'jpg', 'jpeg']}
                  types={'.png, .jpg, .jpeg'}
                  forceRemount={forceRemount}
                  // images={true}
                />
                <HStack
                  flex={1}
                  flexWrap={'wrap'}
                >
                  {selectedFiles.length > 0 && (
                    <ViewUploadImageCards
                      ind={0}
                      url={selectedFiles}
                      onDeleteImage={onDeleteImage}
                    />
                  )}
                </HStack>
              </>
            )
          }
          footer={
            <Box width={MobileWindow && '100%'}>
              <CustomButton
                onPress={async () => {
                  LoaderAnimation.show();
                  if (editBannerImage.length > 0) {
                    let payload = { ...eventsDetail };
                    let docs = await uploadFilesToServer(editBannerImage);
                    payload.banner = docs;
                    payload.workflow_instance_id = payload['_id'];
                    let instance_id = payload['_id'];
                    if (isValidDateFormat(payload['from_date']))
                      payload['starts_at'] = getStartDateFormats(
                        payload['from_date'],
                        'start'
                      );
                    if (isValidDateFormat(payload['to_date']))
                      payload['ends_at'] = getStartDateFormats(
                        payload['to_date'],
                        'end'
                      );
                    delete payload['current_step'];
                    delete payload['metadata'];
                    delete payload['status'];
                    delete payload['_id'];
                    delete payload['quiz_title'];
                    let res = await putWorkflowAPI(
                      payload,
                      workflow['event']['_id'],
                      eventsDetail.current_step,
                      instance_id,
                      'EDIT_EVENT'
                    );
                    if (res.error) {
                      toaster(res.message, 'error', 'error');
                      LoaderAnimation.hide();
                      return;
                    } else {
                      toaster(
                        'Banner Updated Successfully',
                        'success',
                        'success'
                      );
                      getEventDetails();
                      closeModal();
                    }
                    LoaderAnimation.hide();
                    closeModal();
                  } else {
                    LoaderAnimation.hide();
                    toaster('Upload Banner Image', 'error', 'error');
                    return;
                  }
                }}
                text='Upload'
                color={COLORS.WHITE_COLOR}
              />
            </Box>
          }
          width={!MobileWindow && '50%'}
          height='fit-content'
        />
      ) : (
        <MobileModelSheet
          isOpen={showModal}
          onClose={closeModal}
          header={'Upload Banner Image'}
          body={
            showModal && (
              <>
                <FileUploader
                  files={selectedFiles}
                  show={false}
                  setFiles={handleFilesSelect}
                  accept={['png', 'jpg', 'jpeg']}
                  types={'.png, .jpg, .jpeg'}
                  forceRemount={forceRemount}
                  // images={true}
                />
                <HStack
                  flex={1}
                  flexWrap={'wrap'}
                >
                  {selectedFiles.length > 0 && (
                    <ViewUploadImageCards
                      ind={0}
                      url={selectedFiles}
                      onDeleteImage={onDeleteImage}
                    />
                  )}
                </HStack>
              </>
            )
          }
          footer={
            <Box width={MobileWindow && '100%'}>
              <CustomButton
                onPress={async () => {
                  LoaderAnimation.show();
                  if (editBannerImage.length > 0) {
                    let payload = { ...eventsDetail };
                    let docs = await uploadFilesToServer(editBannerImage);
                    payload.banner = docs;
                    payload.workflow_instance_id = payload['_id'];
                    let instance_id = payload['_id'];
                    if (isValidDateFormat(payload['from_date']))
                      payload['starts_at'] = getStartDateFormats(
                        payload['from_date'],
                        'start'
                      );
                    if (isValidDateFormat(payload['to_date']))
                      payload['ends_at'] = getStartDateFormats(
                        payload['to_date'],
                        'end'
                      );
                    delete payload['current_step'];
                    delete payload['metadata'];
                    delete payload['status'];
                    delete payload['_id'];
                    let res = await putWorkflowAPI(
                      payload,
                      workflow['event']['_id'],
                      eventsDetail.current_step,
                      instance_id,
                      'EDIT_EVENT'
                    );
                    if (res.error) {
                      toaster(res.message, 'error', 'error');
                      LoaderAnimation.hide();
                      return;
                    } else {
                      toaster(
                        'Banner Updated Successfully',
                        'success',
                        'success'
                      );
                      getEventDetails();
                      closeModal();
                    }
                    LoaderAnimation.hide();
                    closeModal();
                  } else {
                    LoaderAnimation.hide();
                    toaster('Upload Banner Image', 'error', 'error');
                    return;
                  }
                }}
                text='Upload'
                color={COLORS.WHITE_COLOR}
              />
            </Box>
          }
          maxH={'80vh'}
          position='hidden'
        />
      )}
    </>
  );
};

export default RequestDetail;
